import { assembleMediahostUrl } from './helpers.js';

export default function ImagePreview({ imageSrc, initialState, alt }) {
    return (
        <div className="relative w-full h-full overflow-hidden rounded">
            <img
                src={assembleMediahostUrl(imageSrc, initialState ?? {})}
                alt={alt}
                className="object-cover w-full h-full"
            />
        </div>
    );
}
